<template>
  <h1 class="p-login-logo">
    <login-logo-image />
  </h1>
</template>